import { useState, useEffect } from "react";
import { Calendar, Badge,Form,message,Row,Col } from "antd";
import dayjs from "dayjs";
import ElectricityLogs from "./ElectricityLogs";
import JCBLogs from "./JCBLogs";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import CreateRecordDrawer from "../Record/CreateRecordDrawer";
import CreateRecordModal from "../Record/CreateRecordModal";
import { generateBody, formatRecordData, fetchLookupData} from '../Components/Utility';
import isEqual from 'lodash/isEqual';

const Logbook = () => {
//   const [logs] = useState([
//     { date: "2025-02-10", jcb_number: "JCB-101", driver: "John Doe", contractor: "ABC Constructions", jcb_usage: 5, meter_number: "MTR-001", morning_reading: 1200, evening_reading: 1230 },
//     { date: "2025-02-11", jcb_number: "JCB-102", driver: "Jane Smith", contractor: "XYZ Builders", jcb_usage: 90, meter_number: "MTR-002", morning_reading: 1250, evening_reading: 1300 },
//   ]);
  const [form] = Form.useForm();

  const [logEntries, setLogEntries] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [logDataLoading, setLogDataLoading] = useState(true);

  // State for Drawer
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [objectName] = useState("LogEntry"); // Assuming the object name
  const [fieldsDataDrawer, setFieldsDataDrawer] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [loading, setLoading] = useState(false);
  const [creationView, setCreationView] = useState("");
  const [layout, setLayout] = useState([]);

  useEffect(() => {
    fetchObjMetadata();
    fetchMetadata();
    fetchLogEntries();
  }, []);

  const fetchObjMetadata = async () => {
    try {

      const apiServiceForObject = new ApiService(
        `${BASE_URL}/get_mt_object_by_name/LogEntry`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const objectResponse = await apiServiceForObject.makeCall();
      console.log('objectres:',objectResponse);
      console.log(objectResponse[0]?.record_creation_view)
      setCreationView(objectResponse[0]?.record_creation_view);

      const layouts = new ApiService(`${BASE_URL}/get_by_objectName/LogEntry`, {}, 'GET');
        
      const res = await layouts.makeCall();
      if(res){
          const activeLayout = res.filter(layout => layout.active);
          setLayout(activeLayout);
      }

    } catch (error) {
      console.log("Error fetching metadata:", error);
    }
  };

  const fetchMetadata = async () => {
    try {

      const apiServiceForFields = new ApiService(
        `${BASE_URL}/mt_fields/object/LogEntry`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const response = await apiServiceForFields.makeCall();
      setFieldsDataDrawer(response); // Store field metadata for the drawer
    } catch (error) {
      console.log("Error fetching metadata:", error);
    }
  };
  const handleFinish = async (values, saveAndNew = false) => {
    const updatedValues = generateBody(fieldsDataDrawer, values,(selectedRecord?._id && !selectedRecord?.isClone) ? false : true);
     if(updatedValues==="error"){
        return;
      }
    const changedValues = {};

    if(selectedRecord?._id){
    
    Object.keys(updatedValues).forEach((key) => {
        const newValue = updatedValues[key];
        const oldValue = selectedRecord[key];

        const isNewKey = !(key in selectedRecord);
        const isEmpty = newValue === "" || newValue === null || newValue === undefined;

        if (!isEqual(newValue, oldValue)) {
            if (!isNewKey || (isNewKey && !isEmpty)) {
                changedValues[key] = newValue;
            }
        }
    });

    // Remove keys with undefined values
    Object.keys(changedValues).forEach(key => {
      if (changedValues[key] === undefined) {
        delete changedValues[key];
      }
    });
  }


    
    const body = {
      object_name: objectName,
      data: {
        _id: selectedRecord?._id && !selectedRecord?.isClone ? selectedRecord._id : undefined, // If cloning, exclude the ID
        ...((selectedRecord?.isClone || !selectedRecord?._id) ? updatedValues : changedValues)
      }
    };


    try {
      setLoading(true);
      // Create an instance of ApiService for the POST request
      const apiService = new ApiService(
        `${BASE_URL}/insert_or_update_records`,
        { 'Content-Type': 'application/json' },
        'POST',
        body
      );

      const response = await apiService.makeCall();
      console.log('response:::::', response);
      message.success(selectedRecord?._id && !selectedRecord?.isClone ? 'Record updated successfully' : 'Record created successfully');

      if(creationView === "Modal"){
        setModalVisible(false);
      }
      else{
        setDrawerVisible(false);
      }
      fetchLogEntries();
      // form.resetFields();
      if (!saveAndNew) {
        if(creationView === "Modal"){
          setModalVisible(false);
        }
        else{
          setDrawerVisible(false);
        }
        form.resetFields();
    //     if(isCreateNewRecord){
    //       navigate(`/record/${objectName}/${response.id}`, { state: { response, objectid: id } });
    //       }
    //       fetchRecords(selectedView,currentPage);
    //   } else {
    //     form.resetFields(); // Reset the form for new object creation
    //   }
      }
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save record due to an unknown error';
      message.error(errorMessage);
    } finally {
       setLoading(false); // Ensure loading is stopped regardless of success or failure
    }
  };

  const fetchLogEntries = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/fetch_records/Log_Entry`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const response = await apiService.makeCall();
      setLogEntries(response?.records);
      console.log('res:::',response);
    } catch (error) {
      console.log("Error fetching log entries:", error);
    } finally {
      setLogDataLoading(false);
    }
  };


  const handleFinishFailed = (errorInfo) => {
    console.log("Form submission failed:", errorInfo);
  };


  const dateCellRender = (value) => {
    const formattedDate = value.format("YYYY-MM-DD"); // Format for matching

    // Filter logs for the selected date
    const logsForDate = logEntries.filter(log => dayjs(log.Date).format("YYYY-MM-DD") === formattedDate);

    if (logsForDate.length > 0) {
        // Sum JCB usage
        const totalJCBUsage = logsForDate.reduce((sum, log) => sum + (log.JCBUsage || 0), 0);

        // Sum Morning and Evening Readings
        const totalMorningReading = logsForDate.reduce((sum, log) => sum + (log.MorningReading || 0), 0);
        const totalEveningReading = logsForDate.reduce((sum, log) => sum + (log.EveningReading || 0), 0);

        return (
            <div>
                {totalJCBUsage > 0 && <Badge color="blue" text={`JCB: ${totalJCBUsage} hrs`} />}
                {totalMorningReading > 0 && totalEveningReading > 0 && (
                    <Badge color="purple" text={`Used: ${ totalEveningReading - totalMorningReading} kWh`} />
                )}
            </div>
        );
    }

    return null;
};




return (
  <div style={{ maxWidth: 1000, margin: "auto" }}>
    <h1
      style={{
        // padding: "10px 0px",
        // zIndex: 1000,
        height: "20px",
      }}
    >
      Logs Calendar
    </h1>
    
    <br />

    <Calendar
      style={{ marginTop: "5px" }}
      dateCellRender={dateCellRender}
      onSelect={(date, { source }) => {
        if (source === "date") {
          setSelectedDate(date);
          if(creationView === "Modal"){
            setModalVisible(true);
          }
          else{
            setDrawerVisible(true);
          }
        }
      }}
      onPanelChange={(value, mode) => {
        console.log("Panel changed to:", mode, value.format("MM/YYYY"));
        if(creationView === "Modal"){
          setModalVisible(false);
        }
        else{
          setDrawerVisible(false);
        } // Close drawer when changing months
      }}
    />

    <div style={{ marginTop: "15px" }}>
      <JCBLogs logEntries={logEntries} logDataLoading={logDataLoading} />
      <ElectricityLogs logEntries={logEntries} logDataLoading={logDataLoading} />
    </div>

    {/* Drawer instead of Modal */}
    {drawerVisible && (
      <CreateRecordDrawer
        objectName={objectName}
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        onFinish={handleFinish}
        loading={loading}
        fieldsData={fieldsDataDrawer}
        selectedRecord={selectedRecord}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        form={form}
        handleFinishFailed={handleFinishFailed}
        logbook={true}
      />
    )}

{modalVisible && (
      <CreateRecordModal
        objectName={objectName}
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        onFinish={handleFinish}
        loading={loading}
        fieldsData={fieldsDataDrawer}
        selectedRecord={selectedRecord}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        form={form}
        handleFinishFailed={handleFinishFailed}
        logbook={true}
        // layout={layout}
      />
    )}
  </div>
);

};

export default Logbook;